"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _useShoppingCurrency = _interopRequireDefault(require("../../../shop/useShoppingCurrency"));

var _ProductImgList = _interopRequireDefault(require("../../../components/ProductImgList"));

var _withNullIfStaticBuild = _interopRequireDefault(require("../../../withNullIfStaticBuild"));

var _useHomePageHotTips = _interopRequireDefault(require("./useHomePageHotTips"));

//
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      paddingBottom: theme.spacing(3)
    }
  };
}, {
  name: 'CvoHomePageHotTips'
});

function HomePageHotTips(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  var currency = (0, _useShoppingCurrency.default)();
  var hotTips = (0, _useHomePageHotTips.default)();
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(_ProductImgList.default, {
    title: t('homepage/hotTips'),
    products: hotTips,
    currency: currency
  }));
}

process.env.NODE_ENV !== "production" ? HomePageHotTips.propTypes = {
  classes: _propTypes.default.shape({
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string
} : void 0;
HomePageHotTips.defaultProps = {
  classes: undefined,
  className: undefined
};

var _default = (0, _withNullIfStaticBuild.default)(HomePageHotTips);

exports.default = _default;